import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from './View/Home';
import Deploy from "./View/Deploy";
import Release from "./View/Release"
import Add from "./View/Add"
import Return from "./View/Return"
import Swap from "./View/Swap"
import Resupply from "./View/Resupply"
import Reship from "./View/Reship"
import Template from "./View/Template"

import 'bootstrap/dist/css/bootstrap.min.css';
import './Asset/CSS/main.css';
import Login from "./View/Login";
import { useSelector } from "react-redux"
import Users from "./View/User/User";
import Lookup from "./View/Lookup";


function RouteWrapper(props) {
  return (
    <>
      {
        !props.isLoggedIn ?
          <props.component />
          :
          <>
            <div>
              <div className="layout-wrapper">
                <div className="pageLayout">
                  <props.component />
                </div>
              </div>
            </div>
          </>
      }
    </>
  );
}

function AdminRoute({ element: Element, ...rest }) {
  return localStorage.role == 'Admin' ? (
    <Element {...rest} />
  ) : (
    <Navigate to="/dashboard" replace />
  );
}

function App(props) {
  const { auth } = useSelector((state) => state)
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.isLoggedIn);

  useEffect(() => {
    setIsLoggedIn(localStorage.isLoggedIn)
  }, [localStorage, auth.isAuthenticated])

  return (
    <>
      {
        isLoggedIn ?
          // true ?

          <Routes>
            <Route path="/" element={<Deploy />} />
            <Route path="/dashboard" element={<Home />} />

            <Route path="/template/deploy" element={<Deploy key="deploy-no-id" />} />
            <Route path="/template/release" element={<Release key="deploy-no-id" />} />
            <Route path="/template/add" element={<Add key="deploy-no-id" />} />
            <Route path="/template/return" element={<Return key="deploy-no-id" />} />
            <Route path="/template/swap" element={<Swap key="deploy-no-id" />} />
            <Route path="/template/resupply" element={<Resupply key="deploy-no-id" />} />
            <Route path="/template/reship" element={<Reship key="deploy-no-id" />} />
            <Route path="/template/status" element={<Reship key="deploy-no-id" />} />


            <Route path="/template/deploy/:templateId" element={<Deploy key="deploy-with-id" />} />
            <Route path="/template/release/:templateId" element={<Release key="deploy-with-id" />} />
            <Route path="/template/add/:templateId" element={<Add key="deploy-with-id" />} />
            <Route path="/template/return/:templateId" element={<Return key="deploy-with-id" />} />
            <Route path="/template/swap/:templateId" element={<Swap key="deploy-with-id" />} />
            <Route path="/template/resupply/:templateId" element={<Resupply key="deploy-with-id" />} />
            <Route path="/template/reship/:templateId" element={<Reship key="deploy-with-id" />} />
            <Route path="/template/status/:templateId" element={<Reship key="deploy-no-id" />} />


            <Route path="/login" element={<Login />} />
            <Route path="/template" element={<Template />} />

            {/* Protected Admin Routes */}
            <Route
              path="/users"
              element={<AdminRoute element={Users} />}
            />
            <Route
              path="/lookup"
              element={<AdminRoute element={Lookup} />}
            />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          :
          <Routes>
            <Route path="/" element={<RouteWrapper component={Login} isLoggedIn={isLoggedIn} />} />
            <Route path="/login" element={<RouteWrapper component={Login} isLoggedIn={isLoggedIn} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
      }
    </>
  );
}

export default App;